export const EventSchema = function (event) {

    const utcTime = new Date(0), 
        currentTime = new Date().getTime()
    utcTime.setUTCSeconds(event.start_time)

    this.team_one_iso = event && event.team_one_iso || '';
    this.team_two_iso = event && event.team_two_iso || '';
    this.recent_bets = event && event.recent_bets || [];
    this.eventId = event && event.eventId;
    this.venue = event && event.venue || '';
    this.team_one_colour = event && event.team_one_colour || '';
    this.team_two_colour = event && event.team_two_colour || '';
    this.bets_for_one = event && event.bets_for_one || 0;
    this.bets_for_two = event && event.bets_for_two || 0;
    this.totalBetsCount = this.bets_for_one + this.bets_for_two;
    this.duration = event && event.duration || 0;
    this.finalized = event && event.finalized || false;
    this.start_time = event && event.start_time || 0;
    this.team_one = event && event.team_one || null;
    this.team_two = event && event.team_two || null;
    this.team_one_name = event && event.team_one_name || null;
    this.team_two_name = event && event.team_two_name || null;
    this.totalPoolSize = event && (event.bets_for_one + event.bets_for_two) || 0;
    this.startTimeUTC = utcTime.toUTCString();
    this.startTimeLocal = utcTime.toLocaleString('en-US', { month: 'numeric', day: '2-digit', hour: 'numeric', minute: '2-digit' });
    this.state = event.start_time > currentTime ? (event.start_time + event.duration > currentTime ? 'ENDED' : 'STARTED') : 'PENDING';

}


// WEBPACK FOOTER //
// ./src/schemas/event.js